import { useEffect, useRef } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import Input from './Input';
import mapboxgl from 'mapbox-gl';  // Add this import
import 'mapbox-gl/dist/mapbox-gl.css';
import Spinner from '../../Plateforme/Atoms/Spinner';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const SuggestionsContainer = styled.div`
    background-color: #fff;
    position: absolute;
    border: 1px solid #ddd;
    border-radius: 4px;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
`;

const AdressInput = ({ ...props }) => {

    const timeoutRef = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const mapContainerRef = useRef(null);

    // Initialize all state variables
    const [adresse, setAdresse] = useState(props.adressDefaultValue || "");
    const [latitude, setLatitude] = useState(props.latitudeDefaultValue || "");
    const [longitude, setLongitude] = useState(props.longitudeDefaultValue || "");
    const [suggestions, setSuggestions] = useState([]);
    const [isLoadingSuggestions, setIsLoadingSuggestions] = useState(false);
    const [shouldShowSuggestions, setShouldShowSuggestions] = useState(false);

    // Initialize Mapbox access token
    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiZGdjb2Jvc3MiLCJhIjoiY2xzY2JnajIzMGZsNzJpcGM4b3l5OWttaCJ9.1GzkF8EERgQ5u1jkmP3C7w';
    }, []);

    // Update state when props change
    useEffect(() => {
        if (props.adressDefaultValue !== undefined) {
            setAdresse(props.adressDefaultValue);
        }
        if (props.latitudeDefaultValue !== undefined) {
            setLatitude(props.latitudeDefaultValue);
        }
        if (props.longitudeDefaultValue !== undefined) {
            setLongitude(props.longitudeDefaultValue);
        }
    }, [props.adressDefaultValue, props.latitudeDefaultValue, props.longitudeDefaultValue]);

    // Handle address change
    useEffect(() => {
        // Clear previous timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        if (adresse.length > 2) {
            setIsLoadingSuggestions(true);
            
            // Debounce the API call
            timeoutRef.current = setTimeout(async () => {
                try {
                    const response = await fetch(
                        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(adresse)}.json?access_token=${mapboxgl.accessToken}`
                    );
                    const data = await response.json();
                    setSuggestions(data.features);
                } catch (error) {
                    console.error('Geocoding error:', error);
                } finally {
                    setIsLoadingSuggestions(false);
                }
            }, 300);
        } else {
            setSuggestions([]);
        }
    }, [adresse]);

    // Initialize map when coordinates change
    useEffect(() => {
        if (longitude && latitude) {
            const lng = parseFloat(longitude);
            const lat = parseFloat(latitude);

            if (!mapRef.current) {
                mapRef.current = new mapboxgl.Map({
                    container: mapContainerRef.current,
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [lng, lat],
                    zoom: 15
                });

                markerRef.current = new mapboxgl.Marker({ draggable: true })
                    .setLngLat([lng, lat])
                    .addTo(mapRef.current);

                // Update coordinates when marker is dragged
                markerRef.current.on('dragend', () => {
                    const { lng, lat } = markerRef.current.getLngLat();
                    setLongitude(lng);
                    setLatitude(lat);
                });
            } else {
                mapRef.current.setCenter([lng, lat]);
                markerRef.current.setLngLat([lng, lat]);
            }
        }
    }, [longitude, latitude]);

    const handleSuggestionClick = (suggestion) => {
        const [longitude, latitude] = suggestion.center;
        setAdresse(suggestion.place_name);
        setLongitude(longitude.toString());
        setLatitude(latitude.toString());
        setShouldShowSuggestions(false);
    };

    return (
        <div style={{position: "relative"}}>
            <Input
                name={props.adressInputName}
                required={props.required}
                style={{width:"100%"}}
                placeholder={props.placeholder}
                value={adresse}
                onChange={(e) => setAdresse(e.target.value)}
                onFocus={() => setShouldShowSuggestions(true)}
                // onBlur={() => setTimeout(() => setShouldShowSuggestions(false), 200)}
            />
            <input readOnly hidden name={props.latitutdeInputName} value={latitude}/>
            <input readOnly hidden name={props.longitudeInputName} value={longitude}/>
            {shouldShowSuggestions && (isLoadingSuggestions || suggestions.length > 0) && <SuggestionsContainer>
                {isLoadingSuggestions && (<>
                    <br/><br/>
                    <Spinner />
                    <br/><br/>
                </>)}
                {!isLoadingSuggestions && suggestions.length > 0 && suggestions[0] !== adresse && (
                    <div>
                        {suggestions.map((suggestion) => (
                            <div
                                key={suggestion.id}
                                onClick={() => handleSuggestionClick(suggestion)}
                                style={{
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #eee'
                                }}
                            >
                                {suggestion.place_name}
                            </div>
                        ))}
                    </div>
                )}
            </SuggestionsContainer>}
            
            {/* Map preview */}
            {longitude && latitude && (
                <div
                    ref={mapContainerRef}
                    style={{
                        height: '200px',
                        marginTop: '10px',
                        borderRadius: '4px',
                        overflow: 'hidden'
                    }}
                />
            )}
        </div>
    );
};

export default AdressInput;
